import { render, staticRenderFns } from "./StudentDocUploadSidebar.vue?vue&type=template&id=fd321e30&scoped=true&"
import script from "./StudentDocUploadSidebar.vue?vue&type=script&lang=js&"
export * from "./StudentDocUploadSidebar.vue?vue&type=script&lang=js&"
import style0 from "./StudentDocUploadSidebar.vue?vue&type=style&index=0&id=fd321e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd321e30",
  null
  
)

export default component.exports